<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="dialog = true"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible.sync="dialog"
      width="500px"
      top="3vh"
      :modal="false"
    >
      <el-switch
        v-model="active"
        :active-value="1"
        :inactive-value="0"
        active-color="#13ce66"
        :inactive-color="active === null ? '#dcdfe6' : '#ff4949'"
        active-text="Published"
        inactive-text="Not Published"
        @change="filter()"
      ></el-switch>
      <el-input
        class="mt10"
        type="text"
        v-model="name"
        placeholder="Label name"
        clearable
        @clear="filter()"
        @keyup.native.enter="filter()"
      />
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      name: '',
      active: 0
    }
  },
  methods: {
    ...mapActions('newReleasesLabels', ['read']),
    ...mapMutations('newReleasesLabels', ['setPage']),

    filter() {
      this.setPage(1)
      this.read({
        name: this.name,
        active: this.active
      })
    },

    clear() {
      this.read()
      this.name = ''
      this.active = null
    }
  }
}
</script>
